import { LinkedPatient } from 'hydra-data-types';
import { useAuthStore } from '../store/AuthStore';
import { ConnectInitializeUser } from '../store/StoreTypes';

/**
 * Custom hook to access linkedPatients data from the auth store
 * @returns an array of LinkedPatient objects or undefined if not available
 */
export const useLinkedPatients = (): LinkedPatient[] | undefined => {
  return useAuthStore((state) => {
    const hcpUser = state.user as ConnectInitializeUser;
    return hcpUser?.linkedPatients;
  });
};
